import {CBAR_I18N_SOURCE_ADDED_EVENT} from '@cbar/cbar-i18n';

/**
 * PaymentNGN-specific strings not yet in the CBAR baseline dictionary.
 * Merged additively with `@cbar/cbar-localizations` via the same event channel.
 */
const paymentNgnResources = {
  en: {
    translation: {
      Date: 'Date',
      Amount: 'Amount',
      Receipt: 'Receipt',
      'View receipt': 'View receipt',
      'Total payments': 'Total payments',
      'Recent payments': 'Recent payments',
      Payments: 'Payments',
      Organisation: 'Organisation',
      'Your profiles': 'Your profiles',
      'Next payment': 'Next payment',
      'Active recurring payments': 'Active recurring payments',
      'You have not made any payments yet.': 'You have not made any payments yet.',
      Campaign: 'Campaign',
      'Select profile': 'Select profile',
      'Please select your profile from the list below.': 'Please select your profile from the list below.',
      'You do not currently have a profile.': 'You do not currently have a profile.',
      'Previous payments': 'Previous payments',
      Invoices: 'Invoices',
      'Recurring payments': 'Recurring payments',
      'Payment methods': 'Payment methods',
      'Saved payment methods': 'Saved payment methods',
      'Invoice number': 'Invoice number',
      Status: 'Status',
      Invoice: 'Invoice',
      Download: 'Download',
      Cancelled: 'Cancelled',
      "Doesn't expire": "Doesn't expire",
      'You have no recurring payments set up.': 'You have no recurring payments set up.',
      'You have no payment methods saved.': 'You have no payment methods saved.',
      'Add payment method': 'Add payment method',
      Success: 'Success',
      'Feel free to close this dialog using the confirm button below': 'Feel free to close this dialog using the confirm button below',
      Confirm: 'Confirm',
      'Are you sure?': 'Are you sure?',
      Cancel: 'Cancel',
      Recurring: 'Recurring',
      card: 'card',
      'debit account': 'debit account',
      'recurring payment': 'recurring payment',
      'This will remove your selected': 'This will remove your selected',
      'Please confirm below.': 'Please confirm below.',
      Dashboard: 'Dashboard',
      'My Account': 'My Account',
      Admin: 'Admin',
      Logout: 'Logout',
    },
  },
};

if (typeof globalThis !== 'undefined' && globalThis.window) {
  globalThis.window.dispatchEvent(
    new CustomEvent(CBAR_I18N_SOURCE_ADDED_EVENT, {
      detail: {
        resources: paymentNgnResources,
        defaults: {
          fallbackLng: 'en-AU',
          currency: 'AUD',
        },
      },
    }),
  );
}
